import { IsBoolean, Length } from 'class-validator';

export class ItemSettingsModel {
  @Length(32, 36)
  public locationId: string;

  @IsBoolean()
  public canParticipateEvent: boolean;

  constructor(
    locationId: string,
    canParticipateEvent: boolean,
  ) {
    this.locationId = locationId;
    this.canParticipateEvent = canParticipateEvent;
  }
}
